import { CertificateGroupsModalInitialState } from './reducers';

export const getCertificateGroupsState = ({ pages: { certificateGroups } }) =>
  certificateGroups as CertificateGroupsModalInitialState;

